export default __webpack_public_path__ + "static/media/icon_kunden.b35c3707.svg";